import { CoreLayoutView } from '@core/widgets';
import { TViewCommonOption } from '@libs/types';
import React from 'react';
import styles from './dash.module.css';

type DashProps = {
    onTouchEnd?: () => void;
} & Pick<TViewCommonOption, 'styleName' | 'parentStyleNames'>;

const Dash = ({ onTouchEnd, styleName, parentStyleNames }: DashProps) => {
    return (
        <div
            className={styles.dashWrapper}
            onClick={(e: React.MouseEvent) => {
                if (onTouchEnd) {
                    e.preventDefault();
                    onTouchEnd();
                }
            }}
            onTouchEnd={(e) => {
                if (onTouchEnd) {
                    e.preventDefault();
                    onTouchEnd();
                }
            }}
        >
            <CoreLayoutView
                styleName={styleName}
                parentStyleNames={parentStyleNames}
                styleProps={{ backgroundColor: 'var(--color-grey_28_tr)', width: 32, height: 4, borderRadius: 2 }}
            />
        </div>
    );
};

export default Dash;
